var exports = {
  "P": "xaf9ae18d--49f78c--label",
};

module.exports = exports;
